import { Component, OnInit, OnDestroy } from "@angular/core";
import { GlobalApp, LoadingStatus } from "../../tools/global";
import { InteractivesService, SubscriptionService } from "../../api/services";
import {
  DropDownItem,
  US_Interactive,
  US_Bookmark,
  US_Filter,
  US_ModifiedInteractive,
  UserState,
  InteractReports, PreFilterKeysModel,
} from "../../api/models";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ShareState } from "../../elements/share-editor/share-editor.component";
import { Observable, Subscription } from "rxjs";
import { UserTypeValue } from "../../api/models-ex/user-type-values";
import {
  CopyInteractiveDialogData,
  CopyInteractiveDialogComponent,
} from "../../dialogs/copy-interactive-dialog/copy-interactive-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { DialogResultType } from "../../dialogs/DialogResult";
import {UserStateEx} from "../../api/models-ex/user-state-ex";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
})
export class HomeComponent implements OnInit, OnDestroy {

  testPreFilterKey: PreFilterKeysModel = {
    name: '',
    daxName: '',
    interactId: 0,
    hierarchyValues: [
      {
        preFilterKeyValueId: 0,
        hierarchyLevel: 1,
        keyValue: 'Parent 1',
        childValues: [
          {
            preFilterKeyValueId: 0,
            hierarchyLevel: 2,
            keyValue: 'Child 1',
            childValues: [
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 1'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 2'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 3'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 4'
              }
            ]
          },
          {
            preFilterKeyValueId: 0,
            hierarchyLevel: 2,
            keyValue: 'Child 2',
            childValues: [
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 5'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 6'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 7'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 8'
              }
            ]
          },
          {
            preFilterKeyValueId: 0,
            hierarchyLevel: 2,
            keyValue: 'Child 3',
            childValues: [
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 9'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 10'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 11'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 12'
              }
            ]
          }
        ]
      },
      {
        preFilterKeyValueId: 0,
        hierarchyLevel: 1,
        keyValue: 'Parent 2',
        childValues: [
          {
            preFilterKeyValueId: 0,
            hierarchyLevel: 2,
            keyValue: 'Child 4',
            childValues: [
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 13'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 14'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 15'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 16'
              }
            ]
          },
          {
            preFilterKeyValueId: 0,
            hierarchyLevel: 2,
            keyValue: 'Child 5',
            childValues: [
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 17'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 18'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 19'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 20'
              }
            ]
          },
          {
            preFilterKeyValueId: 0,
            hierarchyLevel: 2,
            keyValue: 'Child 6',
            childValues: [
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 21'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 22'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 23'
              },
              {
                preFilterKeyValueId: 0,
                hierarchyLevel: 3,
                keyValue: 'Sub Item 24'
              }
            ]
          }
        ]
      }
    ],
    preFilterKeyId: 0,
    keyType: 1
  }

  selectedValues: string[] = [];

  selectedValuesChanged(newValues: string[]) {
    this.selectedValues = newValues;
  }

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
  };
  userStateSubscription: Subscription = null;

  currentSelectedInteractive: US_Interactive = null;
  currentSelectedModifiedInteractive: US_ModifiedInteractive = null;
  currentSelectedFilter: US_Filter = null;
  currentSelectedBookmark: US_Bookmark = null;
  currentSelectedAction: string = "";

  selectedInteractive = "-1";
  selectedFilter = "-1";
  selectedBookmark = "-1";
  selectedReport = "-1";
  selectedAction = "-1";

  availableInteractives: US_Interactive[] = [];
  availableModifiedInteractives: US_ModifiedInteractive[] = [];
  availableFilters: US_Filter[] = [];
  availableBookmarks: US_Bookmark[] = [];
  availableActions: Action[] = [];
  availableReports: InteractReports[] = [];

  interactiveDropDownItems: DropDownItem[];
  filterDropDownItems: DropDownItem[];
  bookmarkDropDownItems: DropDownItem[];
  actionDropDownItems: DropDownItem[];

  initialInteractiveName: string = "Loading Interactives...";

  public shareState: ShareState;

  constructor(
    public app: GlobalApp,
    private interactiveService: InteractivesService,
    private subscriptionService: SubscriptionService,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.interactiveDropDownItems = [];
    this.filterDropDownItems = [];
    this.bookmarkDropDownItems = [];
    this.actionDropDownItems = [];

    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();

        this.interactiveDropDownItems.push({
          display: "--- NO INTERACTIVES ---",
          value: "-1",
          properties: {
            Type: "None",
          },
        });
      } else {
        this.app.refreshUserState(this.subscriptionService);
      }
    });

    this.filterDropDownItems.push({
      display: "--- NO FILTER (DEFAULT) ---",
      value: "-1",
    });

    this.bookmarkDropDownItems.push({
      display: "--- NO BOOKMARK (DEFAULT) ---",
      value: "-1",
    });

    this.actionDropDownItems.push({
      display: "-- NO ACTION --",
      value: "-1",
    });
  }

  ngOnInit() {
    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      let isFirst = false;
      if (this.userState.interactives.length === 0) {
        isFirst = true;
      }

      this.userState = userState;

      this.availableInteractives = [];
      for (let i = 0; i < this.userState.interactives.length; i++) {
        let isAvailable = false;
        for (
          let e = 0;
          e < this.userState.interactives[i].subscriptionHeaders.length;
          e++
        ) {
          if (
            this.userState.interactives[i].subscriptionHeaders[e].userType !==
            UserTypeValue.NoRole
          ) {
            isAvailable = true;
          }
        }

        if (!this.userState.interactives[i].isActive) {
          isAvailable = false;
        }

        if (isAvailable) {
          this.availableInteractives.push(this.userState.interactives[i]);
        }
      }

      this.availableModifiedInteractives = [];
      for (let i = 0; i < this.userState.modifiedInteractives.length; i++) {
        let isAvailable = false;
        for (
          let e = 0;
          e < this.userState.modifiedInteractives[i].subscriptionHeaders.length;
          e++
        ) {
          if (
            this.userState.modifiedInteractives[i].subscriptionHeaders[e]
              .userType !== UserTypeValue.NoRole
          ) {
            isAvailable = true;
          }
        }

        if (isAvailable) {
          this.availableModifiedInteractives.push(
            this.userState.modifiedInteractives[i]
          );
        }
      }

      if (isFirst) {
        if (this.availableInteractives.length > 0) {
          this.selectedInteractive =
            "I-" + this.availableInteractives[0].interactId.toString();
        } else if (this.availableModifiedInteractives.length > 0) {
          this.selectedInteractive =
            "M-" +
            this.availableModifiedInteractives[0].modInteractId.toString();
        }

        this.selectInteractive();

        // this.initialInteractiveName = "-- NO INTERACTIVES --";
      }
    });
  }

  ngOnDestroy() {
    this.userStateSubscription.unsubscribe();
  }

  selectInteractive(): void {
    const interactiveParts = this.selectedInteractive.split("-");
    if (interactiveParts.length !== 2) {
      this.currentSelectedInteractive = null;
      this.currentSelectedModifiedInteractive = null;
    } else {
      const interactType = interactiveParts[0];
      const interactId = interactiveParts[1];
      this.currentSelectedModifiedInteractive = null;
      this.currentSelectedInteractive = null;
      this.availableFilters = [];
      this.availableBookmarks = [];
      this.availableActions = [];
      this.availableReports = [];

      if (interactType === "I") {
        for (let i = 0; i < this.userState.interactives.length; i++) {
          if (
            this.userState.interactives[i].interactId.toString() === interactId
          ) {
            this.currentSelectedInteractive = this.userState.interactives[i];

            this.availableFilters = this.currentSelectedInteractive.filters;
            this.availableBookmarks = this.currentSelectedInteractive.bookmarks;
            this.availableReports = this.currentSelectedInteractive.availableReports;

            this.availableActions.push({
              display: "View",
              action: "view",
            });

            let canCopy = false;
            if (this.currentSelectedInteractive.canCopy) {
              for (
                let e = 0;
                e < this.currentSelectedInteractive.subscriptionHeaders.length;
                e++
              ) {
                if (
                  this.currentSelectedInteractive.subscriptionHeaders[e]
                    .userType == UserTypeValue.Designer
                ) {
                  canCopy = true;
                }
              }
            }

            if (canCopy) {
              this.availableActions.push({
                display: "Copy & Edit",
                action: "copyandedit",
              });
            }

            if (this.availableReports.length > 0) {
              this.selectedReport = this.availableReports[0].interactReportId.toString();
            }

            this.selectedAction = this.availableActions[0].action;
            this.initialInteractiveName = "-- NO INTERACTIVES --";
          }
        }
      } else if (interactType === "M") {
        for (let i = 0; i < this.userState.modifiedInteractives.length; i++) {
          if (
            this.userState.modifiedInteractives[i].modInteractId.toString() ==
            interactId
          ) {
            this.currentSelectedModifiedInteractive = this.userState.modifiedInteractives[
              i
            ];

            this.availableFilters = this.currentSelectedModifiedInteractive.filters;
            this.availableBookmarks = this.currentSelectedModifiedInteractive.bookmarks;

            this.availableActions.push({
              display: "View",
              action: "view",
            });

            let allowEdit = this.currentSelectedModifiedInteractive.allowEdit;

            if (allowEdit) {
              this.availableActions.push({
                display: "Edit",
                action: "edit",
              });
            }

            this.selectedAction = this.availableActions[0].action;

            this.initialInteractiveName = "-- NO INTERACTIVE --";
          }
        }
      }
    }
  }

  interactiveCopyAndEdit(): boolean {
    const dialogData: CopyInteractiveDialogData = {
      dialogTitle: "Copy & Edit Interactive",
      name: "",
      shareState: UserStateEx.getModifiedInteractiveShareState(this.userState,  {
        allowEdit: true,
        shares: [],
        modInteractId: 0,
        subscriptionHeaders: [],
        interactive: undefined,
        bookmarks: [],
        interactId: 0,
        name: '',
        owner: true,
        createdBy: undefined,
        modifiedTimeStamp: undefined,
        powerBidatasetId: undefined,
        userId: 0,
        subscriptionId: 0,
        deleted: false
      }),
      isOwner: true,
      userSubscriptions: this.currentSelectedInteractive.subscriptionHeaders,
    };

    const dialogRef = this.dialog.open(CopyInteractiveDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        const params: InteractivesService.InteractivesDuplicateInteractiveParams = {
          interactiveId: this.currentSelectedInteractive.interactId,
          newName: result.ResultData,
        };

        this.app.pushLoading("Creating Interactive");

        this.interactiveService
          .interactivesDuplicateInteractive(params)
          .subscribe(
            (result) => {
              const queryStringParams = {
                interactId: result.properties.ModifiedInteractiveId,
                interactType: "ModifiedInteractive",
                actionType: "edit",
                filterId: "-1",
                bookmarkId: "-1",
                reportId: "-1"
              };

              this.app.popLoading();
              this.router.navigate([
                "powerbi-embedded",
                queryStringParams.interactId,
                queryStringParams.interactType,
                queryStringParams.actionType,
                queryStringParams.filterId,
                queryStringParams.bookmarkId,
                queryStringParams.reportId
              ]);
              return false;
            },
            (error) => {
              var e = 0;
            }
          );
      }
    });

    return false;
  }

  goClick(): boolean {
    const interactiveParts = this.selectedInteractive.split("-");
    if (interactiveParts.length === 2) {
      const interactType = interactiveParts[0];
      const interactId = interactiveParts[1];

      if (this.selectedAction != "copyandedit") {
        const queryStringParams = {
          interactId,
          interactType:
            interactType === "M" ? "ModifiedInteractive" : "Interactive",
          actionType: this.selectedAction,
          filterId: this.selectedFilter,
          bookmarkId: this.selectedBookmark,
          reportId: this.userState.reportOnly ? this.selectedReport : "-1"
        };

        this.router.navigate([
          "powerbi-embedded",
          queryStringParams.interactId,
          queryStringParams.interactType,
          queryStringParams.actionType,
          queryStringParams.filterId,
          queryStringParams.bookmarkId,
          queryStringParams.reportId
        ]);
      } else {
        this.interactiveCopyAndEdit();
      }
    }

    return false;
  }
}

export interface Action {
  display: string;
  action: string;
}
